<template>
  <div>
    <div class="gdlr-core-pbf-wrapper" style="padding-top: 70px; padding-bottom: 70px;" id="gdlr-core-wrapper-2">
      <div class="gdlr-core-pbf-background-wrap" style="background-color: #0a0a0a;"></div>
      <div class="gdlr-core-pbf-background-wrap" style="bottom: -5px;">
        <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js" style="opacity: 0.8; background-image: url(static/upload/slider-2-bg.jpg); background-size: cover; background-position: bottom center;" data-parallax-speed="0"></div>
      </div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js">
        <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
          <div class="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first" id="gdlr-core-column-40407">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js" style="padding-top: 110px; padding-bottom: 120px;">
              <div class="gdlr-core-pbf-background-wrap">
                <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js" style="background-repeat: no-repeat; background-position: top center;" data-parallax-speed="0"></div>
              </div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js" style="max-width: 620px;">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-bottom gdlr-core-item-pdlr" style="padding-bottom: 50px;">
                    <div class="gdlr-core-title-item-title-wrap">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title" style="font-size: 52px; font-weight: 500; text-transform: none; color: #ffffff;">
                        服务订阅<span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                      </h3>
                    </div>
                    <span class="gdlr-core-title-item-caption gdlr-core-info-font gdlr-core-skin-caption" style="font-size: 18px; font-style: normal; color: #d8d8d8;">
                      Get updates for new classes and new products
                    </span>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-contact-form-7-item gdlr-core-item-pdlr gdlr-core-item-pdb">
                    <div role="form" class="wpcf7" id="wpcf7-f1979-p1964-o1" lang="en-US" dir="ltr">
                      <div class="screen-reader-response">
                        <p role="status" aria-live="polite" aria-atomic="true"></p>
                        <ul></ul>
                      </div>
                      <div>
                        <input type="text" placeholder="姓名:" class="input" v-model="sub.name">
                        <input type="text" placeholder="公司:" class="input" v-model="sub.company">
                        <input type="text" placeholder="手机号:" class="input" maxlength="11" v-model="sub.mobile">
                        <input type="text" placeholder="Email:" class="input" v-model="sub.email">
                        <input type="button" value="订阅" class="submit-button" v-on:click="subscribe">
                      </div>
                    </div>
                  </div>
                  <div class="gdlr-core-newsletter-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-style-round2" style="padding-bottom: 0px;" id="gdlr-core-newsletter-1" v-if="0">
                    <div class="newsletter newsletter-subscription">
                      <div class="gdlr-core-newsletter-form clearfix">
                        <div class="gdlr-core-newsletter-email">
                          <input class="newsletter-email gdlr-core-skin-e-background gdlr-core-skin-e-content" placeholder="电子邮件地址" type="email" name="ne" size="30" required="" v-model="sub.email">
                        </div>
                        <div class="gdlr-core-newsletter-submit">
                          <input class="newsletter-submit" type="submit" v-on:click="subscribe" value="订阅">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserToken, updateUserToken, getUserSubInfo } from '@/libs/user'
import { setToken, getToken, delToken } from '@/libs/util'
import AppMixin from '@/libs/app-mixin'

export default {
  name: 'Subscribe',
  mixins: [AppMixin],
  data () {
    return {
      sub: {
        name: '',
        company: '',
        mobile: '',
        email: '',
        is_sub: true
      },
      token: ''
    }
  },
  methods: {
    change () {
      this.token = this.$route.params.token
      console.log(this.token)
      console.log(getToken())
      if (typeof this.token !== 'undefined') {
        delToken()
      }
      console.log(getToken())
      if (getToken() === false) {
        if (typeof this.token === 'undefined') {
          if (this.isWechat()) {
            this.signWechat()
            return false
          }
          location.href = 'index.html'
        } else {
          setToken(this.token)
          location.href = '#/subscribe'
        }
      } else if (getToken() !== '') {
        this.getUserToken()
      }
    },
    getUserSubInfo () {
      getUserSubInfo().then(res => {
        this.sub.name = res.result.name
        this.sub.company = res.result.company
        this.sub.mobile = res.result.mobile
        this.sub.email = res.result.email
      })
    },
    getUserToken () {
      getUserToken().then(res => {
        if (res.code !== 200) {
          location.href = 'index.html'
          return false
        }
        this.getUserSubInfo()
      })
    },
    updateUserToken () {
      updateUserToken(this.sub).then(res => {
        if (res.code !== 200) {
          this.$message(res.msg)
          return false
        }
        this.$message({
          message: '订阅成功',
          type: 'success'
        })
        alert('订阅成功')
        this.sub = {
          name: '',
          company: '',
          mobile: '',
          email: '',
          is_sub: true
        }
        if (this.isWechat()) {
          // TODO 模板消息
        }
      })
    },
    subscribe () {
      console.log(this.sub)
      if (this.sub.name.length === 0) {
        this.$message('请输入姓名')
        return false
      }
      if (this.sub.company.length === 0) {
        this.$message('请输入公司')
        return false
      }
      if (this.sub.mobile.length === 0) {
        this.$message('请输入手机号')
        return false
      }
      if (this.sub.email.length === 0) {
        this.$message('请输入电子邮箱')
        return false
      }
      this.updateUserToken()
    },
    signWechat () {
      let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxc6bedfe165674e76&redirect_uri=https%3A%2F%2Fapi.huidetrust.com%2Fservice%2Ftest%2Fuser.do%2Fsignup&response_type=code&scope=snsapi_userinfo&state=SUB_1pvNabRfx8CUvfSkkFtfkzA&connect_redirect=1#wechat_redirect'
      location.href = url
    }
  },
  mounted () {
    this.change()
    console.log(this.isWechat())
  },
  watch: {
    $route: 'change'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Subscribe.vue